import React, { useContext } from 'react';
import { Trans } from '@lingui/react';
import Router from 'next/router';
import styled from 'styled-components';
import Button from '../components/buttons';
import { Box, Container, Flex } from './../components/layout/Grid';
import { H1Error, PError } from './../components/texts';
import { UserContext } from '../lib/contexts/UserProvider';
import LanguageContext from '@lib/contexts/languageContext';

const BackgroundImage = styled.div`
  background-image: ${props => (props.url ? `url(${props.url})` : null)};
  background-size: cover;
  background-position: center;
  min-height: 551px;
`;

const Layout = props => (
  <BackgroundImage url="/static/404-bg.jpg">
    <Flex
      flexDirection="column"
      justifyContent={'center'}
      px={['10px', '90px', '90px']}
      style={{ height: '100%', minHeight: '550px' }}
    >
      <Box width={[1, 1, 1 / 2]}>
        <H1Error>{props.title}</H1Error>
      </Box>
      <Box width={[1, 1, 1 / 2]} mb="30px">
        <PError>{props.description}</PError>
      </Box>
      <Box width={[1, 1, 1 / 2]}>{props.actions}</Box>
    </Flex>
  </BackgroundImage>
);

const Error = props => {
  const locale = useContext(LanguageContext);
  const [currentUser, { loading }] = useContext(UserContext);

  if (loading) return null;

  return (
    <Container fullWidth flexDirection={'column'}>
      {props.statusCode === 404 ? (
        <Layout
          backgroundImage="/static/404-bg.jpg"
          title="404"
          description={
            <React.Fragment>
              {currentUser ? (
                <Trans
                  id="error.dear_visitor"
                  message={`Dear {name}`}
                  values={{
                    name: currentUser.firstName,
                  }}
                />
              ) : (
                <Trans
                  id="error.dear_visitor"
                  message={`Dear {name}`}
                  values={{
                    name: <Trans id="metadata.visitor" message={`visitor`} />,
                  }}
                />
              )}
              <br />
              <Trans
                id="error.body_404_part1"
                message={`You are trying to acces a page on Yogobe which does not seem to exist. Please email us`}
              />
              {` `}
              <a href="mailto: info@yogobe.com">info@yogobe.com</a>
              {` `}
              <Trans
                id="error.body_404_part2"
                message={`or use our search feature to find what it is you are looking for. Thank you for visiting Yogobe.`}
              />
            </React.Fragment>
          }
          actions={
            <Button
              appearance="default-white"
              onClick={() => {
                Router.push(`/${locale}/me/dashboard`);
              }}
            >
              <Trans id="error.action" message={`Take me Home`} />
            </Button>
          }
        />
      ) : (
        <Layout
          backgroundImage="/static/500-bg.jpg"
          title={<Trans id="error.server_error" message={`Server Error`} />}
          description={
            <React.Fragment>
              {currentUser ? (
                <Trans
                  id="error.dear_visitor"
                  message={`Dear {name}`}
                  values={{
                    name: currentUser.firstName,
                  }}
                />
              ) : (
                <Trans
                  id="error.dear_visitor"
                  message={`Dear {name}`}
                  values={{
                    name: <Trans id="metadata.visitor" message={`visitor`} />,
                  }}
                />
              )}
              <br />
              <Trans
                id="error.body_500"
                message={`For some unworldly reason you have landed here. There seems to be a server error. Please refresh the page or try again in a short while. We also welcome you to help us out by reporting this!`}
                components={[<a key="1" href="mailto:data@yogobe.com"></a>]}
              />
            </React.Fragment>
          }
          actions={
            <Box>
              <Flex mx="-5px">
                <Box mx="5px">
                  <Button
                    appearance="default-white"
                    onClick={() => {
                      Router.push(`/${locale}/me/dashboard`);
                    }}
                  >
                    <Trans id="error.action" message={`Take me Home`} />
                  </Button>
                </Box>
                {/* <Box mx="5px">
                    <Button
                      appearance="outline"
                      color={'white'}
                      onClick={() => {
                        Sentry.showReportDialog({
                          eventId: Sentry.lastEventId,
                        });
                      }}
                    >
                      <Trans
                        id="error.report"
                        message={`Report this issue`}
                      />
                    </Button>
                  </Box> */}
              </Flex>
            </Box>
          }
        />
      )}
    </Container>
  );
};

Error.getInitialProps = ctx => {
  const { res, err } = ctx;
  const statusCode = res ? res.statusCode : err ? err.statusCode : null;
  return { statusCode };
};

Error.displayName = 'ErrorPage';

export default Error;
